let mypackChild = [{
        path: "",
        component: () =>
            import (
                /* webpackChunkName: 'imcl-manage */
                "@/components/mypacks/manage/Manage.vue"
            ),
        name: "manage"
    },
    {
        path: "renew",
        component: () =>
            import (
                /* webpackChunkName: 'imcl-manage */
                "@/components/mypacks/renew/Renew.vue"
            ),
        name: "renew"
    }
];
let myprofileChild = [{
        path: "",
        component: () =>
            import (
                /* webpackChunkName: 'imcl-manage */
                "@/components/myprofile/details/Details.vue"
            ),
        name: "details"
    },
    {
        path: "kyc",
        component: () =>
            import (
                /* webpackChunkName: 'imcl-manage */
                "@/components/myprofile/kyc/KYC.vue"
            ),
        name: "kyc"
    },
    {
        path: "transactions",
        component: () =>
            import (
                /* webpackChunkName: 'imcl-transactionhistory */
                "@/components/transactionHistory/TransactionHistory.vue"
            ),
        name: "transactions"
    }
];
let helpChild = [
  {
    path: "",
    component: () =>
      import(
        /* webpackChunkName: 'imcl-manage */ "@/components/help/faq/FAQ.vue"
      ),
    name: "faq"
  },
  {
    path: "customersupport",
    component: () =>
      import(
        /* webpackChunkName: 'nxt-customersupport */ "@/components/help/customerSupport/CustomerSupport.vue"
      ),
    name: "customersupport"
  }
];
let menuChildren = [{
        path: "",
        component: () =>
            import (
                /* webpackChunkName: 'imcl-myIndigital */
                "@/components/myindigital/MyIndigital.vue"
            ),
        name: "mynxtdigital"
    },
    {
        path: "mypacks",
        component: () =>
            import (
                /* webpackChunkName: 'imcl-mypacks */
                "@/components/mypacks/MyPacks.vue"
            ),
        name: "manage",
        children: mypackChild
    },
    {
        path: "addpacks",
        component: () =>
            import (
                /* webpackChunkName: 'imcl-addpacks */
                "@/components/addpacks/AddPacks.vue"
            ),
        name: "addpacks"
    },
    {
        path: "myprofile",
        component: () =>
            import (
                /* webpackChunkName: 'imcl-myprofile */
                "@/components/myprofile/MyProfile.vue"
            ),
        name: "details",
        children: myprofileChild
    },
    {
        path: "help",
        component: () =>
            import ( /* webpackChunkName: 'imcl-help */ "@/components/help/Help.vue"),
        name: "help",
        children: helpChild
    },
    {
        path: "alert",
        component: () =>
            import ( /* webpackChunkName: 'nxt-help */ "@/components/alert/Alert.vue"),
        name: "alert",
    },
    {
        path: "contactus",
        component: () =>
            import (
                /* webpackChunkName: 'imcl-contactus */
                "@/components/contactus/ContactUs.vue"
            ),
        name: "contactus"
    },
    {
        path: "/checkout",
        component: () =>
            import (
                /* webpackChunkName: 'imcl-checkout */
                "@/components/checkout/Checkout.vue"
            ),
        name: "checkout"
    },
    // {
    //   path: "transactionhistory",
    //   component: () =>
    //     import(
    //       /* webpackChunkName: 'nxt-transactionhistory */ "@/components/transactionHistory/TransactionHistory.vue"
    //     ),
    //   name: "transactionhistory"
    // },
    {
        path: "description",
        component: () =>
            import (
                /* webpackChunkName: 'nxt-description */
                "@/components/description/Description.vue"
            ),
        name: "description"
    },
    {
        path: "logout",
        component: () =>
            import (
                /* webpackChunkName: 'imcl-logout */
                "@/components/logout/Logout.vue"
            ),
        name: "logout"
    },
    // {
    //   path: "/myaccountchild/:link",
    //   component: () =>
    //     import(
    //       /* webpackChunkName: 'imcl-myaccountchild */ "@/components/myaccount/myAccount.vue"
    //     ),
    //   name: "myaccountchild"
    // },
    {
        path: "topup",
        component: () =>
            import (
                /* webpackChunkName: "imcl-topup" */
                "@/components/myindigital/TopUpParent.vue"
            ),
        name: "topup"
    }
];
export const routes = [{
        path: "/",
        name: "login",
        component: () =>
            import (
                /* webpackChunkName: 'imcl-account' */
                "@/components/account/MainAccount.vue"
            )
    },
    {
        path: "/ottquickpay",
        name: "ottquickpay",
        component: () =>
            import (
                /* webpackChunkName: 'imcl-instantpayment' */
                "@/components/ottQuickpay/OttQuickpay.vue"
            )
    },
    {
        path: "/instantpayment",
        name: "instantpayment",
        component: () =>
            import (
                /* webpackChunkName: 'imcl-instantpayment' */
                "@/components/instantPayment/InstantPayment.vue"
            )
    },
    {
        path: "/qrscan/:id",
        name: "qrscan",
        component: () => import (/* webpackChunkName: 'nxtdigtital-qrScan' */"@/components/qrScan/QRScan.vue")
    },
    {
        path: "/hdupgrade",
        name: "hdupgrade",
        component: () =>
            import (
                /* webpackChunkName: 'imcl-hdupgrade' */
                "@/components/hdUpgrade/HDUpgrade.vue"
            )
    },
    {
        path: "/instantpaymentconfirm/:id",
        name: "instantpaymentconfirm",
        component: () =>
            import (
                /* webpackChunkName: 'imcl-instantPaymentConfirm' */
                "@/components/instantPayment/instantPaymentConfirm.vue"
            )
    },
    {
        path: "/maintenance",
        name: "maintenance",
        component: () =>
            import (
                /* webpackChunkName: 'nxt-account' */
                "@/components/maintenance/Maintenance.vue"
            )
    },
    {
        path: "/maintenancelogin",
        name: "maintenancelogin",
        component: () =>
            import (
                /* webpackChunkName: 'nxt-maintenancelogin' */
                "@/components/maintenance/MainAccount.vue"
            )
    },
    {
        path: "/nxtselfcareportal",
        component: () =>
            import (
                /* webpackChunkName: 'imcl-init */
                "@/components/init/InitView.vue"
            ),
        children: menuChildren,
        name: "home"
    },
    {
        path: "/surveyquestions",
        component: () =>
            import (
                /* webpackChunkName: 'imcl-init */
                "@/components/surveyquestions/MainSurveyQuestion.vue"
            ),
        name: "surveyquestions"
    },
    {
        path: "/paymentstatuscheck",
        name: "paymentstatuscheck",
        component: () =>
            import (
                /* webpackChunkName: 'imcl-paymentstatuscheck' */
                "@/components/verifyPaymentStatus/VerifyPaymentStatus.vue"
            )
    }
];


// WEBPACK FOOTER //
// ./src/router/routes.js